/**
 * 这个工具主要的是处理图表的方法
 */
import commonUtils from './commonUtils';
import { chartColors } from '../components/ABSChart/chartTheme';
import { moment } from './momentUtils';

/**
 * 设置图表的axis的title
 * @param x
 * @param y
 */
export function AxisTitle(x: string, y: string[]) {
  return { x, y };
}

/**
 * 获取chart的series，当传送了xAction,会返回{ xList, seriesList }
 * @param data  数据
 * @param xAction x的数据处理
 * @param yAction y的数据处理
 * @param tooltip tooltip的数据处理
 * @param itemStyle 每一个数据item的处理
 */
export function getChartSeries(
  data: any,
  xAction?: any,
  yAction?: any,
  tooltip?: any,
  itemStyle?: any
) {
  if (!data || !data.line_series || data.line_series.length === 0) {
    return [];
  }
  const seriesList: any = [];
  let xList: Array<any> = [];
  commonUtils.isPlus = 0;
  if (data.line_series) {
    data.line_series.map((series, index) => {
      let dataList: any = [];
      series.data.data.forEach(point => {
        const x = xAction ? xAction(point) : Number.parseFloat(moment(point.x).format('x'));
        const y = yAction ? yAction(point) : Number.parseFloat(String(point.y));
        const tooltips = tooltip ? tooltip(point) : point.tooltip;
        if (xList.indexOf(x) === -1) {
          xList.push(x);
        }
        if (tooltips) {
          dataList.push({ x: x, y: y, tooltip: tooltips });
        } else {
          dataList.push([x, y]);
        }
      });
      const content = itemStyle ? itemStyle(series, index) : {};
      let seriesData = {
        name: series.name,
        type: series.type,
        data: dataList,
        step: series.step,
        stacking: series.stacking,
        dashStyle: series.dash_style,
        ...content
      };
      // 特殊处理只有两个序列的颜色问题，两个序列必须都是柱状图或者都是线图
      if (data.line_series.length === 2 && index === 1) {
        let isSpeicalTreatment =
          data.line_series.filter(item => item.type.toString().indexOf('line') > -1).length === 2 ||
          data.line_series.filter(item => item.type.toString().indexOf('column') > -1).length === 2;
        if (isSpeicalTreatment) {
          seriesData.color = chartColors.colors1[3];
        }
      }
      seriesList.push(seriesData);
    });
  }
  if (xAction) {
    return { xList, seriesList };
  }
  return seriesList;
}

/**
 * 获取 图表 marker 的样式
 * @param series
 * @param index
 */
export function getMarkerStyles(series: any, index: number) {
  const colors = chartColors.colors1;
  const isAgain = String(series.name).indexOf('说明书') >= 0;
  return {
    marker: { enabled: !1 },
    color: isAgain ? colors[commonUtils.isPlus++ % colors.length] : colors[index % colors.length]
  };
}

// 基准利率曲线key-value的对应转换
export function formatMaturityText(value: string) {
  if (value.indexOf('_') > -1) {
    const vList = value.split('_');
    const year = vList[2].split('Y');
    return commonUtils.convertToChinaNum(year[0]) + '年' + vList[0] + '(' + vList[1] + ')';
  }
  return value;
}

/**
 * @description: y轴左边坐标轴的文字显示
 * @param {string} title
 */
export function leftTitleReserver(title: string) {
  return titleReserver(title, true);
}

/**
 * @description: y轴右边坐标轴的文字显示
 * @param {string} title
 */
export function rightTitleReserver(title: string) {
  return titleReserver(title, false);
}

/**
 * 旋转文字为竖直方向
 * @param {string} title
 * @param {boolean} direction 方向，true表示表示左边坐标轴，反之右坐标轴
 */
export function titleReserver(title: string, direction: boolean) {
  if (direction) {
    title = title
      .split('')
      .reverse()
      .join('');
  }
  var split = title.split('');
  let textDeg = direction ? 90 : -90;
  let symbolDeg = direction ? 180 : 0;
  var rlt: any = [];
  let symbol = ['(', ')', '（', '）'];
  split.forEach(function(letter: any) {
    let deg = textDeg;
    if (symbol.some(item => item === letter)) {
      deg = symbolDeg;
    }
    rlt.push(`<span style="transform:rotate(${deg}deg);
      display: inline-block;">${letter}</span>`);
  });
  return rlt.join('');
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/chartUtils.ts